export const convertTwentyFourHourTimeToSeconds = (
  time: Partial<TwentyFourHourTime>,
) => {
  return (time.hour ?? 0) * 3600 + (time.minute ?? 0) * 60
}
